import React, { useRef } from "react";
import withStyles from '@mui/styles/withStyles';
import emailImage from "../../assets/images/icon_profil_grey.svg";
const styles = (theme) => ({
  email: {
    border: "none",
    background: "white",
    outline: "none",
    height: "100%",
    width: "100%",
    fontSize: "12px",
    fontFamily: "Montserrat",
    fontWeight: "400",
  },
  inputWrapper: {
    border: "1px solid #70707052",
    background: "white",
    borderRadius: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 18px",
  },
  image: {
    height: "18px",
    width: "20px",
    padding: "0px 12px 0px 0px",
  },
});

const EmailInputTransparent = ({ classes }) => {
  const emailInput = useRef(null);
  return (
    <>
      <div
        className={classes.inputWrapper}
        onClick={(e) => emailInput.current.focus()}
      >
        <img src={emailImage} className={classes.image} alt="" />
        <input
          type="email"
          ref={emailInput}
          className={classes.email}
          placeholder="E-Mail"
        />
      </div>
    </>
  );
};
export default withStyles(styles)(EmailInputTransparent);
